import { render } from "./EmployeeListDrawer.vue?vue&type=template&id=2a65eb1c&ts=true"
import script from "./EmployeeListDrawer.vue?vue&type=script&lang=ts"
export * from "./EmployeeListDrawer.vue?vue&type=script&lang=ts"

import "./EmployeeListDrawer.vue?vue&type=style&index=0&id=2a65eb1c&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__